import { render, staticRenderFns } from "./SubjectSeoEn.vue?vue&type=template&id=52142aee&"
import script from "./SubjectSeoEn.vue?vue&type=script&lang=js&"
export * from "./SubjectSeoEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports